import React from 'react';
import Radium from 'radium';

import Divider from 'muicss/lib/react/divider';

import AppUtil from 'AppUtil';

import {A, Button, Img} from 'views/AppElements';

import StockAddModalForm from 'views/admin/StockAddModalForm';
import StockMoveModalForm from 'views/admin/StockMoveModalForm';
import StockHistoryModal from 'views/admin/StockHistoryModal';

import ReactTable from 'react-table';

const STOCK_OPERATION = {ADD: "ADD", MOVE: "MOVE", REMOVE: "REMOVE", VIEW_HISTORY: "VIEW_HISTORY"};


const EachProductStocks = Radium((props) => {

    const previewImage = props.previewImage;
    const stocks = props.stocks;
    const showLoading = stocks? false: true;

    const isAdmin = props.isAdmin;

    let columns = [{Header: 'Size', accessor: 'productSize',
                    Cell: function(rowData) {
                        return <div style={{textAlign: 'center'}}><b>{rowData.value}</b></div>
                    }},
                    {Header: 'Quantity', accessor: 'quantity',
                    Cell: function(rowData) {
                        const quantity = rowData.value;
                        let quantityClass = "stockquantity sufficientQuantity";
                        if(quantity <=0)
                            quantityClass = "stockquantity lowQuantity";
                        else if (quantity < 5)
                            quantityClass = "stockquantity belowAverageQuantity";

                        return <div className={quantityClass}>{quantity}</div>;
                    }}, 
                    {Header: 'History', accessor: 'stockProductId', width: 200, 
                            Cell: function(rowData) {
                                return <div>
                                    <Button mui="true" style={{background: "gray", color: 'white'}} onClick={() => props.onShowStockProductHistory(rowData.original)}>View History</Button>
                                </div>
                    }},
                ];

    
    if(isAdmin === true) {
        const actionCol = {Header: 'Action', accessor: 'stockProductId', width: 200, 
                        Cell: function(rowData) {
                            
                            return <div>
                                    <Button mui="true" color="primary" style={{background: "#60af60"}} onClick={() => props.onShowAddStockProduct(rowData.original)}>+</Button>
                                    <Button mui="true" disabled={rowData.original.quantity <= 0} onClick={() => props.onShowMoveStockProduct(rowData.original)}>Move</Button>
                                </div>
                    }};
        columns.push(actionCol);
    }

    const title = stocks? stocks[0].product.title: null;
    const productUrl = stocks? AppUtil.getProductURL(stocks[0].product): "#";
    return <div className="flexRow eachProductStocks">
            
            <div className="flexColumn stockPreviewContainer">
                <Img src={previewImage} className="stockPreview" />
                <div className="stockProductTitle">
                    <A href={productUrl} target="_blank">{title}</A>
                </div>
            </div>

            <ReactTable data={stocks? stocks: []} columns={columns} minRows={5} 
						noDataText="No Stocks Found." loading={showLoading} 
                        defaultPageSize={10}
                        className="stocks-table"
                         />
    </div>
});

class EachStockOwner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {selectedStockProduct: null, operation: null};
        this.onSuccess = this.onSuccess.bind(this);

        this.onShowAddStockProduct = this.onShowAddStockProduct.bind(this);
        this.onShowMoveStockProduct = this.onShowMoveStockProduct.bind(this);
        this.onShowStockProductHistory = this.onShowStockProductHistory.bind(this);
    }

    onShowAddStockProduct(stockProduct) {
        this.setState({selectedStockProduct: stockProduct, operation: STOCK_OPERATION.ADD})
    }

    onShowMoveStockProduct(stockProduct) {
        this.setState({selectedStockProduct: stockProduct, operation: STOCK_OPERATION.MOVE})
    }

    onShowStockProductHistory(stockProduct) {
        this.setState({selectedStockProduct: stockProduct, operation: STOCK_OPERATION.VIEW_HISTORY})
    }

    onSuccess() {
        this.setState({selectedStockProduct: null, operation: null});
    }

    render() {
        const owner = this.props.stockOwner;
        const stocks = this.props.stocks;

        
        const productStocks = stocks? stocks.reduce(function(h, stock) {
                                        h[stock.product.previewImage] = (h[stock.product.previewImage] || []).concat(stock);
                                        return h; 
                                    }, {}): [];

        const stockList = Object.keys(productStocks).map(previewImage => {
            return <EachProductStocks key={"stock_product_preview_"+previewImage} 
                                        previewImage={previewImage} stocks={productStocks[previewImage]}
                                        stockOwner={this.props.stockOwner}
                                        onShowAddStockProduct={this.onShowAddStockProduct}
                                        onShowMoveStockProduct={this.onShowMoveStockProduct}  
                                        onShowStockProductHistory={this.onShowStockProductHistory} 
                                        isAdmin={this.props.isAdmin}/>
        });

        const hasCredit = owner.creditBalance && owner.creditBalance > 0;
        return <div style={{marginTop: '20px'}}>
            <Divider />
            <h1 className="flexRow" style={{justifyContent: "space-between", textAlign: 'center'}}>
                <span className="ownerName" style={{flexGrow: 1}}>{owner.ownerAlias} Stocks</span>
                {
                    hasCredit === true &&
                    <span className="ownerCredit">Credit: <b>Rs. {owner.creditBalance}</b></span>
                }
            </h1>

            <div id="stockList" className="flexColumn">
                {stockList}
            </div>

            {
                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.ADD &&
                <StockAddModalForm stockProduct={this.state.selectedStockProduct} stockOwner={owner} onSuccess={this.onSuccess} />
            }

            {
                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.MOVE &&
                <StockMoveModalForm stockProduct={this.state.selectedStockProduct} stockOwner={owner} allOwners={this.props.allOwners} onSuccess={this.onSuccess}/>
            }

            {
                this.state.selectedStockProduct && this.state.operation === STOCK_OPERATION.VIEW_HISTORY &&
                <StockHistoryModal stockProduct={this.state.selectedStockProduct} onSuccess={this.onSuccess}/>
            }

            
        </div>
    }
}

export default Radium(EachStockOwner);


// WEBPACK FOOTER //
// ./src/views/admin/EachStockOwner.js